





























































import { Vue, Component } from 'vue-property-decorator';
import { Icon } from 'vant';

Vue.use(Icon);

@Component
export default class SyAudioPlayer extends Vue {
  player!: HTMLAudioElement;
  duration: number = 0;
  currentTime: number = 0;
  totalTime: string = '00:00';
  durationUpdateFlag = true;
  timer: any = undefined;
  displayTime = '00:00';
  indicatorWidth = 0;
  touchStartPositionX = 0;
  lastPositionX = 0;
  traveled = 0;
  playerWidth = 0;
  shouldTransition = false;
  playerProgressPercent = 0;
  percentage = 0;
  isDraging = false;
  isPlaying = false;

  get playProgress() {
    return Math.round((this.traveled * 100) / this.playerWidth);
  }

  mounted() {
    const playerEl = this.$refs.playerContainer as HTMLDivElement;

    this.playerWidth = playerEl.clientWidth;
    // console.log(playerEl.getBoundingClientRect());
    this.player = this.$refs.player as HTMLAudioElement;
    this.player.addEventListener('loadedmetadata', () => {
      this.duration = this.player.duration;
      this.totalTime = `${this.formatTime(
        this.duration,
        'min',
      )}:${this.formatTime(this.duration, 'sec')}`;
    });
    this.player.addEventListener('timeupdate', () => {
      if (!this.durationUpdateFlag) {
        return;
      }
      clearTimeout(this.timer);
      this.currentTime = this.player.currentTime;
      // 更新滑块
      if (!this.isDraging) {
        this.traveled =
          Math.round((this.currentTime * 100) / this.duration) *
          this.playerWidth *
          0.01;
      }
      // 当前播放时间
      this.displayTime = `${this.formatTime(
        this.currentTime,
        'min',
      )}:${this.formatTime(this.currentTime, 'sec')}`;

      this.durationUpdateFlag = false;

      this.timer = setTimeout(() => {
        this.durationUpdateFlag = true;
      }, 500);
    });
    this.player.addEventListener('ended', () => {
      this.isPlaying = false;
    });
    this.player.addEventListener('pause', () => {
      this.isPlaying = false;
    });
    this.player.addEventListener('play', () => {
      this.isPlaying = true;
    });
  }
  formatTime(timeseconds: number, type: 'min' | 'sec'): string {
    let result = '';
    const singleToDoubleDigi = (p: number) => {
      return p < 10 ? `0${p}` : `${p}`;
    };
    if (type === 'min') {
      result = singleToDoubleDigi(Math.floor(timeseconds / 60));
    } else if (type === 'sec') {
      result = singleToDoubleDigi(Math.floor(timeseconds % 60));
    }
    return result;
  }
  play() {
    this.player.play();
  }
  pause() {
    this.player.pause();
  }
  controlProgress(type: 'forward' | 'backward') {
    const step = 10;
    if (type === 'forward') {
      if (this.player.currentTime + step > this.duration) {
        return (this.player.currentTime = this.duration);
      }
      this.player.currentTime += step;
    } else if (type === 'backward') {
      if (this.player.currentTime - step < 0) {
        return (this.player.currentTime = 0);
      }
      this.player.currentTime -= step;
    }
  }
  onProgressBarTouch(e: PointerEvent) {
    // console.log(e);
    this.shouldTransition = true;
    this.traveled = e.clientX - this.$el.getBoundingClientRect().left;
    this.player.currentTime = this.duration * this.playProgress * 0.01;
  }
  onIndicatorTouchStart(e: TouchEvent) {
    // console.log('touch start:', e);
    this.touchStartPositionX = e.touches[0].pageX; // 记录滑动时的起点
    this.lastPositionX = this.traveled; // 读取上一次已滑动的距离
    this.shouldTransition = false;
  }
  onIndicatorTouchEnd(e: TouchEvent) {
    this.isDraging = false;
    this.player.currentTime = this.duration * this.playProgress * 0.01;
  }
  onIndicatorTouchMove(e: TouchEvent) {
    this.isDraging = true;
    const currentDotPositionX = e.touches[0].pageX; // 滑动时的瞬时X轴坐标
    const deltaX = currentDotPositionX - this.touchStartPositionX; // 偏移值，每一次移动的距离
    let diff = deltaX + this.lastPositionX; // 计算本次滑动的距离
    if (diff > this.playerWidth) {
      diff = this.playerWidth;
    } else if (diff < 0) {
      diff = 0;
    }
    this.traveled = diff; // 保存已滑动的距离
  }
}
